export enum ReceiptApprovalStatus {
  UPLOADING = "UPLOADING",
  UPLOADED = "UPLOADED",
  UPLOAD_FAILED = "UPLOAD_FAILED",
  WAITING_FOR_APPROVAL = "WAITING_FOR_APPROVAL",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  EXTRACT_FAILED = "EXTRACT_FAILED",
  REQUESTING_CREATE_INTERACTION = "REQUESTING_CREATE_INTERACTION",
  COMPLETED = "COMPLETED",
}
